import styled from 'styled-components';
import { Button } from 'antd';

export const Container = styled.div`
  padding: 16px;
`;

export const Label = styled.div`
  margin-bottom: 5px;
`;

export const SendButton = styled(Button)`
  margin-top: 18px;
`;

export const ListWrapper = styled.div`
  overflow: auto;
  max-height: 40vh;
  padding-right: 16px;
`;
